import { useEffect, useRef, useState } from 'react'
import './breadcrumb.scss'

type BreadcrumbProps = {
  projectId?: string
  projectName?: string
  siteId?: string
  siteName?: string
  siteDesignId?: string
  siteDesignName?: string
}

const Breadcrumb = ({ projectId, projectName, siteId, siteName, siteDesignId, siteDesignName }: BreadcrumbProps) => {
  const breadcrumbRef = useRef<HTMLDivElement | null>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  // Function to check if any `xsd-breadcrumb__adaptable-name` is truncated
  const checkTruncation = () => {
    if (breadcrumbRef.current) {
      const adaptableSections = breadcrumbRef.current.querySelectorAll<HTMLDivElement>('.xsd-breadcrumb__section-name-adaptable')

      // Check truncation for adaptable sections
      const hasTruncation = Array.from(adaptableSections).some(name => name.offsetWidth < name.scrollWidth)

      setIsTruncated(hasTruncation)
    }
  }

  useEffect(() => {
    checkTruncation() // Check on mount
    window.addEventListener('resize', checkTruncation) // Re-check on window resize

    return () => {
      window.removeEventListener('resize', checkTruncation)
    }
  }, [])

  const backToProjectsUrl = '/'
  const backToSitesUrl = projectId ? '/project/' + projectId + '/site' : '/'
  const backToSiteDesignsUrl = projectId && siteId ? '/project/' + projectId + '/site/' + siteId + '/sitedesign' : '/'

  return (
    <div ref={breadcrumbRef} className={'xsd-breadcrumb mb-6 msds-text-body-3' + (isTruncated ? ' xsd-breadcrumb--wrappable' : '')}>
      <div className="xsd-breadcrumb__section">
        <a className="xsd-breadcrumb__section-name" href={backToProjectsUrl}>
          Projects
        </a>
        <span className={siteId ? 'xsd-breadcrumb__section-separator' : 'xsd-breadcrumb__section-separator xsd-breadcrumb__section-separator--last'}>/</span>
      </div>
      {projectId && (
        <>
          {siteId ? (
            <>
              <div className="xsd-breadcrumb__section xsd-breadcrumb__section-adaptable xsd-breadcrumb__section--first">
                <a className="xsd-breadcrumb__section-name xsd-breadcrumb__section-name-adaptable" href={backToSitesUrl}>
                  {projectName}
                </a>
                <span className={siteDesignId ? 'xsd-breadcrumb__section-separator' : 'xsd-breadcrumb__section-separator xsd-breadcrumb__section-separator--last'}>/</span>
              </div>
              {siteDesignId ? (
                <>
                  <div className="xsd-breadcrumb__section xsd-breadcrumb__section-adaptable xsd-breadcrumb__section--second">
                    <a className="xsd-breadcrumb__section-name-adaptable" href={backToSiteDesignsUrl}>
                      {siteName}
                    </a>
                    <span className="xsd-breadcrumb__section-separator xsd-breadcrumb__section-separator--last">/</span>
                  </div>
                  <div className={isTruncated ? 'xsd-breadcrumb__section xsd-breadcrumb__section-last xsd-breadcrumb__section-last--wrapped' : 'xsd-breadcrumb__section xsd-breadcrumb__section-last'}>
                    <div className="xsd-breadcrumb__section-name">{siteDesignName}</div>
                  </div>
                </>
              ) : (
                <>
                  <div className={isTruncated ? 'xsd-breadcrumb__section xsd-breadcrumb__section-last xsd-breadcrumb__section-last--wrapped' : 'xsd-breadcrumb__section xsd-breadcrumb__section-last'}>
                    <div className="xsd-breadcrumb__section-name">{siteName}</div>
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              <div className={isTruncated ? 'xsd-breadcrumb__section xsd-breadcrumb__section-last xsd-breadcrumb__section-last--wrapped' : 'xsd-breadcrumb__section xsd-breadcrumb__section-last'}>
                <div className="xsd-breadcrumb__section-name">{projectName}</div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default Breadcrumb
